import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function AppEntry() {
  const navigate = useNavigate();

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const ltiSessionId = searchParams.get("ltisid");

    if (!ltiSessionId) {
      navigate("/lti-required", { replace: true });
      return;
    }

    fetch(
      "https://alignbackendapis-708196257066.asia-southeast1.run.app/session/exchange",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ ltisid: ltiSessionId }),
      }
    )
      .then(() => {
        navigate("/dashboard", { replace: true });
      })
      .catch(() => {
        navigate("/lti-required", { replace: true });
      });
  }, [navigate]);

  return null;
}

